import React from "react";
import { Modal, Button } from "react-bootstrap";
import { getQueryString } from "api/search/filterUrlMaker";
import { _t } from "app/i18n/i18n";
import { getSafeUrl, getSafeTarget } from "utils/urlSafety";

export const LeaveSiteWarning = () => {
  const { url, target = "_blank" } = getQueryString();
  const safeUrl = getSafeUrl(url);
  const safeTarget = getSafeTarget(target);

  return (
    <Modal show={true} onHide={() => window.history.back()}>
      <Modal.Header closeButton>
        <Modal.Title>{_t("Leaving the Global Research Portal")}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>{_t("You are now leaving the Global Research Portal.")}</p>
        <p>
          {_t(
            "Nomura podcasts and videos are presented for informational purposes only and are not Investment Research.",
          )}
        </p>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={() => window.history.back()}>
          {_t("Back")}
        </Button>
        {!safeUrl && <span data-testid="unsafe-url-blocked" style={{ display: "none" }} />}
        {safeUrl && (
          <a href={safeUrl} target={safeTarget} rel="noopener noreferrer" onClick={() => window.history.back()}>
            <Button variant="primary">{_t("Continue")}</Button>
          </a>
        )}
      </Modal.Footer>
    </Modal>
  );
};

// No changes needed; test rendering and click behavior with different query params.
